<template>
  <el-dialog title="审核" :visible.sync="showDialog" @close="handleClose">
    <el-form :model="form" :rules="formRoules" ref="form">
      <!-- 审核进度 -->
      <div class="line">
        <span class="line-title">审核进度</span>
        <div class="line-approval">
        <el-timeline>
          <el-timeline-item
            :color="userItem.recipe.status >= 11800 ? '#0bbd87' : ''"
            size="large"
          >
            处方创建
          </el-timeline-item>
          <!-- <el-timeline-item
            :color="prescriptionStatus || userItem.recipe.status >= 11802 ? '#0bbd87' : ''"
            size="large"
          >
            <p>智能审方</p>
            <template v-if="userItem.recipe.status >= 11802">
              <div v-if="prescriptionStatus" class="auditTag sucsess">
                通过
              </div>
              <div v-else class="auditTag waring">
                未通过
              </div>
            </template>
          </el-timeline-item> -->
          <el-timeline-item
            v-if="!prescriptionStatus"
            :color="userItem.recipe.status >= 11804 ? '#0bbd87' : ''"
            size="large"
          >
            药师初审
            <div v-if="![11804,11808,11806,11809,11807].includes(userItem.recipe.status)" class="auditTag sucsess">待审核</div>
            <div v-else class="auditTag">
              <div v-if="userItem.recipe.status == 11808" class="false">未通过</div>
              <div v-else class="sucsess">审核通过</div>
              <div style="margin-top: 6px;">审核意见：{{ userItem.recipe.pharmacistCause }}</div>
            </div>
          </el-timeline-item>
          <el-timeline-item
            v-if="!prescriptionStatus"
            :color="userItem.recipe.status >= 11806 ? '#0bbd87' : ''"
            size="large"
          >
            药师复审
            <p v-if="![11806,11809,11807].includes(userItem.recipe.status)" class="auditTag sucsess">待审核</p>
            <div v-else class="auditTag">
              <div v-if="userItem.recipe.status == 11809" class="false">未通过</div>
              <div v-else class="sucsess">审核通过</div>
              <div style="margin-top: 6px;">审核意见：{{ userItem.recipe.rePharmacistCause }}</div>
            </div>
          </el-timeline-item>
          <el-timeline-item
            :color="prescriptionStatus || userItem.recipe.status == 11807 ? '#0bbd87' : ''"
            size="large"
          >
            处方生成
          </el-timeline-item>
        </el-timeline>
        </div>
      </div>
      <el-form-item
        label="审核状态"
        :label-width="formLabelWidth"
        prop="auditStatus"
      >
        <el-select
          style="width: 80%"
          v-model="form.auditStatus"
          placeholder="请选择审核状态"
        >
          <el-option label="通过" value="1"></el-option>
          <el-option label="拒绝" value="-1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核意见" :label-width="formLabelWidth" prop="cause">
        <el-input
          style="width: 80%"
          type="textarea"
          :rows="3"
          placeholder="请输入审核意见"
          v-model="form.cause"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false">取 消</el-button>
      <el-button type="primary" @click="audit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { PRESCRIPTION_STATUS } from "@/utils/constants.js";
import { prescriptionCheck, prescriptionReview } from "@/api/doctor";
export default {
  name: "auditDialog",
  props: {
    auditDialogVisible: {
      type: Boolean,
      default: false,
    },
    userItem: {
      type: Object,
      default: {recipe:{ status:11800 }},
    },
  },
  computed:{
    prescriptionStatus(){
      return this.userItem.recipe.status != 11800 && this.userItem.recipe.status != 11801 && this.userItem.recipe.status == 11810
    }
  },
  data() {
    return {
      PRESCRIPTION_STATUS,
      showDialog: false,
      form: {
        auditStatus: "",
        cause: "",
      },
      formLabelWidth: "120px",
      formRoules: {
        auditStatus: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur",
          },
        ],
        cause: [
          {
            required: true,
            message: "请输入审核意见",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 审核
     */
    audit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const params = {
              status: this.form.auditStatus,
              pharmacistCause: this.form.cause,
              recipeId: this.userItem.recipe.id,
            };
            // D11802(11802, "审核药师待审核(医生已签字)", "药师待审（医生已签字）", 1),
            // D11803(11803, "审核药师待签字(审核药师已审核)", "审核药师待签字(审核药师已审核)", 1),
            // D11804(11804, "复核药师待复核(审核药师已签字)", "复核药师待复核(审核药师已签字)", 1),
            let res;
            if (this.userItem.recipe.status == 11803) {
              //签名
              res = await prescriptionSign(params);
            } else if (this.userItem.recipe.status == 11804) {
              //复核
              res = await prescriptionReview(params);
            } else if (this.userItem.recipe.status == 11805) {
              //复核签名
              res = await prescriptionSignReview(params);
            } else {
              //审核
              res = await prescriptionCheck(params);
            }

            if (res.code == 1) {
              if(this.userItem.recipe.status == 11803 || this.userItem.recipe.status == 11805){
                window.location.href = res.data;
                // this.$message({
                //   message: "已提交签名任务至信手书，请在信手书完成下一步签名操作",
                //   type: "success",
                // });
              } else {
                this.$message({
                  message: "设置成功",
                  type: "success",
                });
              }
              this.$emit("refresh-item", 1);
            } else {
              this.$message({
                message: "设置失败",
                type: "warning",
              });
            }
            this.showDialog = false;
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    // 弹出框关闭后触发
    handleClose() {
      // 子组件调用父组件方法，并传递参数
      this.$emit("changeShow", "false");
    },
  },
  watch: {
    // 监听 addOrUpdateVisible 改变
    auditDialogVisible(oldVal, newVal) {
      this.showDialog = this.auditDialogVisible;
    },
  },
};
</script>
<style lang="scss" scoped>
  .line {
    margin: 20px 0;
    padding-left: 15px;
    font-size: 18px;
    color: #333333;
    font-weight: 600;
    line-height: 18px;
    &-title {
      padding-left: 5px;
      border-left: 5px solid #fc701a;
    }
    &-approval {
      margin-top: 15px;
    }
  }
  .auditTag{
    margin-top: 10px;
    font-size: 13px;
  }

  .sucsess{
    color: #409eff;
  }
  .waring{
    color: #e6a23c;
  }
  .false{
    color: #f56c6c;
  }
</style>